import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ConfirmationModal from '../ConfirmationModal';
import Loader from '../../../sections/Resources/components/Loader';
import CloseBtn from '../../../sections/Resources/components/CloseBtn';
import FormModal from '../FormModal';

const Container = styled.div``;

const HeadingContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
    padding: 28px 32px;

    @media only screen and (max-width: 600px) {
        margin-top: 22px;
    }
`;

const Title = styled.h1`
    color: #1d2939;
    font-weight: 500;
    font-size: 28px;
    line-height: 32.66px;
    margin-bottom: 12px;

    @media only screen and (max-width: 600px) {
        font-size: 18px;
        line-height: 20.44px;
    }
`;

const SubTitle = styled.p`
    font-size: 14px;
    line-height: 16.59px;
    color: #212121;
    max-width: 540px;

    @media only screen and (max-width: 600px) {
        font-size: 12px;
        line-height: 14.22px;
        max-width: 100%;
    }
`;

const FormWrapper = ({
    open,
    handleClose,
    formId,
    targetId,
    confirmMessageHeading,
    confirmationMessage,
    heading,
    subTitle,
}) => {
    const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);
    const [isFormLoaded, setIsFormLoaded] = React.useState(true);
    const [isCaptchaLoaded, setIsCaptchaLoaded] = React.useState(false);

    const addScriptToPage = () => {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/embed/v2.js';
        script.async = true;
        script.onload = () => loadHubSpotForm();
        document.body.appendChild(script);
    };

    const loadHubSpotForm = () => {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: process.env.GATSBY_HUBSPOT_PORTAL_ID,
            formId: formId,
            target: `#${targetId}`,
            onFormReady: handleFormReady,
            onFormSubmitted: handleFormSubmitted,
        });
    };

    const handleFormReady = ($form) => {
        addButtonClass($form);
        checkCaptchaLoaded($form);
    };

    const addButtonClass = ($form) => {
        const submitBtnDiv = $form[0].querySelector('.hs-submit');
        if (submitBtnDiv) {
            submitBtnDiv.classList.add('button-sticky');
        }
    };

    const checkCaptchaLoaded = ($form) => {
        const check = () => {
            const captchaIframe = $form[0].querySelector('iframe[title="reCAPTCHA"]');
            if (captchaIframe) {
                setIsCaptchaLoaded(true);
                setIsFormLoaded(false);
            } else {
                setTimeout(check, 100);
            }
        };
        check();
    };

    const handleFormSubmitted = () => {
        setIsFormSubmitted(true);
    };

    React.useEffect(() => {
        if (open) {
            addScriptToPage();

            return () => {
                document.body
                    .querySelectorAll('script[src="https://js.hsforms.net/forms/embed/v2.js"]')
                    .forEach((script) => {
                        document.body.removeChild(script);
                    });
                setIsFormLoaded(true);
                setIsCaptchaLoaded(false);
            };
        }
    }, [open, formId, targetId]);

    const showLoader = isFormLoaded || !isCaptchaLoaded;

    return (
        <FormModal
            open={open}
            isSubmitted={isFormSubmitted}
            setIsFormSubmitted={setIsFormSubmitted}
            handleClose={handleClose}
        >
            <CloseBtn handleClick={handleClose} />
            <Container>
                {isFormSubmitted ? (
                    <ConfirmationModal
                        confirmMessageHeading={confirmMessageHeading}
                        message={confirmationMessage}
                        textAlign="center"
                    />
                ) : (
                    <>
                        <HeadingContainer>
                            <Title>{heading}</Title>
                            <SubTitle>{subTitle}</SubTitle>
                        </HeadingContainer>
                        {showLoader && <Loader />}
                        <div
                            id={targetId}
                            style={{
                                display: showLoader ? 'none' : 'flex',
                                flexDirection: 'column',
                            }}
                        ></div>
                    </>
                )}
            </Container>
        </FormModal>
    );
};

FormWrapper.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    formId: PropTypes.string,
    targetId: PropTypes.string,
    confirmationMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    heading: PropTypes.string,
    subTitle: PropTypes.string,
    confirmMessageHeading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default FormWrapper;
